<template>
  <div :style="'height:' + height">
    <iframe
      v-if="src"
      :id="iframeId"
      style="width: 100%; height: 100%"
      :src="src"
      frameborder="no"
    ></iframe>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { getToken } from "@/utils/auth";

const route = useRoute();
const src = ref();
const iframeId = ref();
function goUrl() {
  const url = route.meta.url;
  iframeId.value = url;
  if (url) {
    src.value = url;
    // if (route.meta.isBlank) {
    //   // 外部url加入token
    //   let tokenStr = "${token}";
    //   if (url.indexOf(tokenStr) !== -1) {
    //     let token = getToken();
    //     src.value = url.replace(tokenStr, token);
    //   }
    //   window.open(src.value, "_blank");
    // }
  }
}
const height = ref(document.documentElement.clientHeight - 94.5 + "px");
goUrl();
</script>
